import React from 'react';

import { useClassName } from 'common/hooks';

import useCustomStyle from '../../hooks';

import './carousel-arrows.less';

export default function CarouselArrows({
  next,
  prev,
  type,
  style,
  theme,
  settings,
  trackDirection,
}) {
  const classNames = useClassName('CLPCarouselArrows');
  const [, customStyle] = useCustomStyle(settings);
  const slidesPerView = settings?.find(
    (setting) => setting.fields.key === '--slides-per-view'
  );

  const arrowIconStyles = Object.fromEntries(
    Object.entries(customStyle)
      .filter(([key]) => key.startsWith('--arrow-icon-'))
      .map(([key, value]) => [key.replace('--arrow-icon-', ''), value])
  );
  const arrowContainerStyles = Object.fromEntries(
    Object.entries(customStyle)
      .filter(([key]) => key.startsWith('--arrow'))
      .filter(([key]) => !key.startsWith('--arrow-icon-'))
      .map(([key, value]) => [key.replace('--arrow-', ''), value])
  );
  const iconSize = arrowIconStyles['size'] || '24px';

  const handleNext = () => {
    if (trackDirection) trackDirection('next');
    next();
  };

  const handlePrev = () => {
    if (trackDirection) trackDirection('prev');
    prev();
  };

  return (
    <div
      className={classNames([
        'container',
        type && type.toLowerCase().split(' ').join('-'),
        type &&
          `${type.toLowerCase().split(' ').join('-')}-${
            slidesPerView ? 'stretch' : 'full'
          }`,
      ])}
      style={style}>
      <div
        className={classNames('arrow', theme)}
        onClick={handlePrev}
        style={arrowContainerStyles}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={iconSize}
          height={iconSize}
          viewBox="0 0 24 24"
          fill="none">
          <path
            d="M18.5 12H6M6 12L12 6M6 12L12 18"
            stroke="black"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            {...arrowIconStyles}
          />
        </svg>
      </div>
      <div
        className={classNames('arrow', theme)}
        onClick={handleNext}
        style={arrowContainerStyles}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={iconSize}
          height={iconSize}
          viewBox="0 0 24 24"
          fill="none">
          <path
            d="M6 12L18.5 12M18.5 12L12.5 18M18.5 12L12.5 6"
            stroke="black"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            {...arrowIconStyles}
          />
        </svg>
      </div>
    </div>
  );
}
